module.exports = __webpack_public_path__ + "img/BEPOBUS.9d44a364.svg";